import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  HEALTH_RISK_ASSESSMENT_DETAILS_PATH,
  HEALTH_RISK_ASSESSMENT_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const HealthRiskAssessment = lazy(() => import('./pages/HealthRiskSummary'));
const HealthRiskDetails = lazy(() => import('./pages/HealthRiskDetails'));

export const HEALTH_ASSESSMENT_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <HealthRiskAssessment />,
    displayTitle: () => 'Health Risk Assessment',
    pageType: PageType.PRIVATE,
    path: HEALTH_RISK_ASSESSMENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthRiskAssessment,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <HealthRiskDetails />,
    displayTitle: () => 'Health Risk Assessment Details',
    pageType: PageType.PRIVATE,
    path: HEALTH_RISK_ASSESSMENT_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthRiskAssessment,
  },
];
